export const Overflow = `<svg title="Overflow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Overflow">
<circle id="Ellipse 204" cx="6" cy="12" r="1.5" fill="currentcolor"/>
<circle id="Ellipse 205" cx="18" cy="12" r="1.5" fill="currentcolor"/>
<circle id="Ellipse 206" cx="12" cy="12" r="1.5" fill="currentcolor"/>
</g>
</svg>
`;